export default "__VITE_ASSET__QoSyoo7a__"